import {RequestToCancel as RequestToCancelLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';

export type RequestToCancelLetterProps = {
  requestToCancelLetter: RequestToCancelLetter;
};

const RequestToCancel = (props: RequestToCancelLetterProps) => {
  return (
    <>
      <CardField name={'Insured Name'} value={props.requestToCancelLetter.insuredName} ddprivacy="mask"/>
      <CardField name={'Owner Name'} value={props.requestToCancelLetter.ownerName} ddprivacy="mask"/>
      <CardField name={'Owner Address'} value={props.requestToCancelLetter.ownerAddress!.fullAddress} ddprivacy="mask"/>
      <CardField name={'Policy Number'} value={props.requestToCancelLetter.policyNumber} ddprivacy="mask"/>
      <CardField name={'Date'} value={toFormattedDateAsUTC(props.requestToCancelLetter.date)} />
      <CardField name={'Agent Number'} value={props.requestToCancelLetter.agentNumber} />
    </>
  );
};

export default RequestToCancel;
